<template>
  <PageHeader v-if="!isRaw" :title="props.title" :description="props.description">
    <template v-if="$slots.bottom" #bottom>
      <slot name="bottom"></slot>
    </template>
  </PageHeader>

  <ProblemDetailsMessage v-if="error" v-model:error="error" icon="error" :show-error-type="false" />

  <div class="flex flex-col gap-9">
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import { useGlobalConfigStore } from "@/features/Shared";
import { PageHeader } from "@authentication/ui/molecules/PageHeader";
import type { ProblemDetailsType } from "@common/types";
import { ProblemDetailsMessage } from "@common/ui/atoms/Form/ProblemDetailsMessage";

// Props
const props = defineProps({
  description: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
});

// Models
const error = defineModel<ProblemDetailsType | null>("error");

// Variables
const { isRaw } = useGlobalConfigStore();
</script>
